import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./auth/auth.css";
import { API_KEY, BASE_URL, AUTH_BASE_URL } from "./config";

const ResetPassword = ({ expiryToken }) => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  //const [params] = useSearchParams();
  //const token = params.get("token");

  const navigate = useNavigate();

  const handleReset = async () => {
    await fetch(`${AUTH_BASE_URL}/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
      token: expiryToken,
      newPassword: password
    })
    });

    setMessage("Password updated successfully");
    setTimeout(() => navigate("/login"), 1500);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">Reset Password</div>

        {message && <div className="auth-success">{message}</div>}

        <input
          className="auth-input"
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="auth-btn" onClick={handleReset}>
          Update Password
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
